<template>
  <div class="outer-wrapper">
    <div v-if="currentSample.sample_name">
      <van-nav-bar title="样品详情" fixed> </van-nav-bar>
      <van-cell :value="currentSample.display_no" value-class="title-p" />
      <!-- <van-cell :value="''" value-class="sub-title-p" /> -->
      <van-cell
        title="样品名称"
        :value="currentSample.sample_name"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell
        title="样品特性"
        value-class="prop-value"
        title-class="prop-title"
        :label="currentSample.other_property"
      />
      <van-cell
        title="样品状态"
        :value="currentSample.stat"
        value-class="prop-value"
        title-class="prop-title"
      />
      <van-cell
        title="相关检测任务"
        :value="'共' + currentSample.taskList.length + '项'"
        value-class="prop-value"
        title-class="prop-title"
      />
      <div class="sample-list-wrapper">
        <div class="sample-list-inner-wrapper">
          <div
            v-if="currentSample.taskList && currentSample.taskList.length > 0"
            class="prop-value"
          >
            <p v-for="(task, index) in currentSample.taskList" :key="index">
              <span> {{ index + 1 }}. </span>
              <span>
                {{ task.task_name }}
              </span>
            </p>
          </div>
          <p v-else>
            <span>无</span>
          </p>
        </div>
      </div>
      <van-cell
        title="库位信息"
        title-class="cell-t"
        value-class="value-t"
        :value="currentSample.warehouseList.length > 0 ? '已入库' : '未入库'"
      />
      <div v-if="currentSample.warehouseList.length > 0">
        <van-cell
          title="入库时间"
          title-class="cell-t"
          value-class="value-t"
          :value="currentSample.warehouseList[0].in_time"
        />
        <van-cell
          title="当前所占库位："
          :value="'共' + currentSample.warehouseList.length + '个'"
        />
        <van-cell
          :title="index + 1"
          title-class="cell-t"
          value-class="value-t"
          :value="ele.display_no"
          v-for="(ele, index) in currentSample.warehouseList"
          :key="index"
        />
      </div>
      <div class="submit-b-wrapper">
        <van-button type="warning" class="suspend-b" block @click="wareOut"
          >出库</van-button
        >
        <van-button type="info" class="submit-b" block @click="wareIn"
          >入库</van-button
        >
      </div>
    </div>
    <div v-else-if="!currentSample.name">
      <van-empty description="该样品信息已失效（订单重新规划...）" />
    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
//let authData = JSON.parse(localStorage.getItem("authData"));

export default {
  name: "sampleInfo",
  components: {},
  props: {
    enid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentSample: {},
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post(this.$url + "/query_content", {
          userToken: userToken,
          ask_data: "sampleInfo",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.currentSample = response.data.res_record;
            console.log(this.currentSample);
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    goUrl(value) {
      location.href = "/equipment" + value + "/" + this.enid;
    },
    wareOut() {
      this.$axios
        .post(this.$url + "/lab_manage", {
          userToken: userToken,
          ask_data: "wareOut",
          target: "sample",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast.success("出库成功！");
            location.reload();
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
    wareIn() {
      this.$axios
        .post(this.$url + "/lab_manage", {
          userToken: userToken,
          ask_data: "wareIn",
          target: "sample",
          enid: this.enid,
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.$toast("请在1分钟内扫描要放入的库位二维码！");
          } else {
            this.$toast.fail("未找到数据！");
          }
        });
    },
  },
};
</script>
<style scoped>
.title-p {
  font-weight: 700;
  font-size: 0.9rem;
  text-align: center;
}
.sub-title-p {
  text-indent: 1.2rem;
  color: #999;
}

.prop-title {
  color: #999;
  font-size: 0.4rem;
}
.prop-value {
  color: #333;
  font-size: 0.7rem;
}
.spin {
  text-align: center;
  padding-top: 40%;
}

.sample-list-wrapper {
  text-align: center;
  width: 100%;
  word-break: break-all;
}

.sample-list-inner-wrapper {
  margin: 0.5rem 0.6rem;
}

.submit-b-wrapper {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
}

.suspend-b {
  width: 6rem;
}

.record-value {
  text-indent: 1rem;
}

.submit-b-wrapper {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
}

.suspend-b {
  width: 6rem;
}
</style>